import React, { useState } from "react"
import PropTypes from "prop-types"

import { Question } from "./Question"
import { QuestionPostcode } from "./QuestionPostcode"

export const Quote = ({
  allQuestions,
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
}) => {
  const [hasCombiBoiler, setHasCombiBoiler] = React.useState(false)

  const updateAnswers = (answer, value) => {
    setAnswers((answers) => ({ ...answers, [answer]: value }))

    if (answer === "currentBoilerType") {
      if (value === "Combi") {
        setCurrentQuestion((question) => question + 2)
        setHasCombiBoiler(true)
      } else {
        setHasCombiBoiler(false)
        setCurrentQuestion((question) => question + 1)
      }
    } else {
      setCurrentQuestion((question) => question + 1)
    }

    window.scrollTo(0, 0)
    document.getElementById("boiler-quote").scrollTo(0, 0)
  }

  const backFunc = () => {
    if (currentQuestion === 5 && hasCombiBoiler) {
      setCurrentQuestion(currentQuestion - 2)
    } else {
      setCurrentQuestion(currentQuestion - 1)
    }

    window.scrollTo(0, 0)
    document.getElementById("boiler-quote").scrollTo(0, 0)
  }

  return (
    <main
      className="wrapper-width wrapper-height-small boiler-quote"
      id="boiler-quote"
    >
      {allQuestions.map((question, index) => (
        /* Current question - 1 to cause goal gradient effect */
        <Question
          questionValue={question.value}
          answers={question.answers}
          key={question.id}
          id={question.id}
          name={question.name}
          nextFunc={updateAnswers}
          currentQuestion={currentQuestion - 1}
          questionNumber={index}
          tip={question.tip}
        />
      ))}
      <QuestionPostcode
        answers={answers}
        currentQuestion={currentQuestion === allQuestions.length + 1}
      />
      {currentQuestion !== 1 && (
        <button onClick={() => backFunc()} className="boiler-quote-back-button">
          Back
        </button>
      )}
    </main>
  )
}

Quote.propTypes = {
  allQuestions: PropTypes.array.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  setCurrentQuestion: PropTypes.func.isRequired,
  setAnswers: PropTypes.func.isRequired,
  answers: PropTypes.object.isRequired,
}
